import { render } from "./ProductoCreate.vue?vue&type=template&id=79255eef&scoped=true"
import script from "./ProductoCreate.vue?vue&type=script&lang=js"
export * from "./ProductoCreate.vue?vue&type=script&lang=js"

import "./ProductoCreate.vue?vue&type=style&index=0&id=79255eef&scoped=true&lang=scss"

import exportComponent from "C:\\laragon\\www\\framacion_front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79255eef"]])

export default __exports__